import Load from 'components/Load';
import LoadingDots from 'components/LoadingDots';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import Notfound from 'modules/errorpages/Notfound';
import LoggedOut from 'modules/user-environment2/components/LoggedOut';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';
import { useUser } from '~/authentication/store';
import { useLang } from '~/stores/i18n';

const AsyncOverviewPage = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center-overview" */ './components/OverviewPage'
    ),
);
const AsyncCollectionPage = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ './containers/CollectionPageContainer'
    ),
);
const AsyncPreviewPage = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ './components/PreviewPage'
    ),
);
const AsyncSingleArticlePage = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ './components/SingleArticlePage'
    ),
);
const AsyncPreviewCollectionPage = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ './components/PreviewCollectionPage'
    ),
);
const AsyncVideoArticlePAge = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center" */ './containers/VideoArticlePageContainer'
    ),
);
const AsyncCoursePage = Load(
  () =>
    import(
      /* webpackChunkName: "learning-center-course" */ './containers/CoursePageContainer'
    ),
);

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const {
    isLoggedIn,
    isHost,
    isOnboardingHost,
    isOnboardingHostWebinar,
    isAdmin,
    loading,
  } = useUser();
  const lang = useLang();
  if (!loading && !isLoggedIn) {
    return <LoggedOut title={'Login to view this content'} />;
  }

  if (loading) {
    return <LoadingDots />;
  }

  if (!isHost && !isOnboardingHost && !isOnboardingHostWebinar && !isAdmin) {
    return <Redirect to={generatePathnameWithLangCode('/', lang)} />;
  }

  return (
    <Switch>
      <NavigationableLayout
        path={`${path}/course-details/:id`}
        hideFooter
        component={AsyncCoursePage}
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/video/:id`}
        hideFooter
        component={AsyncVideoArticlePAge}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/:category/:id`}
        hideFooter
        component={AsyncCollectionPage}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/article/:category/:id`}
        hideFooter
        component={AsyncSingleArticlePage}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/preview-article/:category/:id`}
        hideFooter
        component={AsyncPreviewPage}
        noNavbar={isCordova()}
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/preview-collection/:id`}
        hideFooter
        component={AsyncPreviewCollectionPage}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        path={path}
        hideFooter
        component={AsyncOverviewPage}
        noNavbar={isCordova()}
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes = (
  <Route path={`${basePath}/learning-center`}>
    <>
      <SubRoutes />
      <AppBottomPushDown />
    </>
  </Route>
);

export default routes;
